import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
{
    id: "po-05-h3v2-01",
    name: "PO 01 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
    size: [1217, 851],
    style: {},
        slots: [          
            { id: "1", x: 30, y: 207, width: 271, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 207, width: 271, height: 436, rotation: 0, imageRotation: 0 },
            { id: "3", x: 686, y: 207, width: 460, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 686, y: 498, width: 226, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 920, y: 498, width: 226, height: 146, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h3v2-02",
    name: "PO 02 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 42, y: 158, width: 520, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 510, width: 256, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 306, y: 510, width: 256, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 638, y: 207, width: 271, height: 436, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 207, width: 271, height: 436, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-03",
    name: "PO 03 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 43, y: 144, width: 524, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 518, width: 126, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 518, width: 125, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 176, y: 518, width: 258, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 651, y: 242, width: 524, height: 366, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-04",
    name: "PO 04 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [  
        { id: "1", x: 29, y: 208, width: 271, height: 436, rotation: 0, imageRotation: 0 },
        { id: "2", x: 308, y: 208, width: 271, height: 436, rotation: 0, imageRotation: 0 },
        { id: "3", x: 657, y: 158, width: 256, height: 182, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 347, width: 520, height: 345, rotation: 0, imageRotation: 0 },
        { id: "5", x: 921, y: 158, width: 255, height: 182, rotation: 0, imageRotation: 0 }
    ],
},

    {
        id: "po-05-h3v2-05",
        name: "PO 05 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 192, width: 390, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 398, y: 192, width: 174, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 462, width: 174, height: 262, rotation: 0, imageRotation: 0 },
            { id: "4", x: 182, y: 462, width: 390, height: 262, rotation: 0, imageRotation: 0 },
            { id: "5", x: 580, y: 192, width: 793, height: 532, rotation: 0, imageRotation: 0 }
        ],
    },

{
    id: "po-05-h3v2-06",
    name: "PO 06 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 239, width: 482, height: 373, rotation: 0, imageRotation: 0 },
        { id: "2", x: 490, y: 239, width: 238, height: 373, rotation: 0, imageRotation: 0 },
        { id: "3", x: 736, y: 239, width: 237, height: 373, rotation: 0, imageRotation: 0 },
        { id: "4", x: 981, y: 239, width: 236, height: 183, rotation: 0, imageRotation: 0 },
        { id: "5", x: 981, y: 430, width: 236, height: 182, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-07",
    name: "PO 07 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 81, y: 135, width: 367, height: 580, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 456, y: 135, width: 406, height: 286, rotation: 0, imageRotation: 0 },
        { id: "3", x: 456, y: 429, width: 406, height: 286, rotation: 0, imageRotation: 0 },
        { id: "4", x: 870, y: 135, width: 265, height: 384, rotation: 0, imageRotation: 0 },
        { id: "5", x: 870, y: 527, width: 265, height: 188, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-08",
    name: "PO 08 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 66, y: 116, width: 391, height: 618, rotation: 0, imageRotation: 0 },
        { id: "2", x: 465, y: 116, width: 285, height: 201, rotation: 0, imageRotation: 0 },
        { id: "3", x: 465, y: 325, width: 285, height: 201, rotation: 0, imageRotation: 0 },
        { id: "4", x: 465, y: 534, width: 285, height: 200, rotation: 0, imageRotation: 0 },
        { id: "5", x: 758, y: 116, width: 392, height: 618, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-09",
    name: "PO 09 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 239, width: 482, height: 373, rotation: 0, imageRotation: 0 },
        { id: "2", x: 490, y: 239, width: 237, height: 374, rotation: 0, imageRotation: 0 },   
        { id: "3", x: 735, y: 239, width: 237, height: 183, rotation: 0, imageRotation: 0 },
        { id: "4", x: 735, y: 430, width: 237, height: 183, rotation: 0, imageRotation: 0 },
        { id: "5", x: 980, y: 239, width: 237, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h3v2-10",
    name: "PO 10 - H3V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 67, y: 116, width: 391, height: 618, rotation: 0, imageRotation: 0 },
        { id: "2", x: 466, y: 116, width: 390, height: 618, rotation: 0, imageRotation: 0 },
        { id: "3", x: 864, y: 116, width: 285, height: 201, rotation: 0, imageRotation: 0 },
        { id: "4", x: 864, y: 325, width: 285, height: 201, rotation: 0, imageRotation: 0 },
        { id: "5", x: 864, y: 534, width: 285, height: 200, rotation: 0, imageRotation: 0 }
    ],
}
];